import { render } from "./TUIViewer.vue?vue&type=template&id=50a1f96c&scoped=true&ts=true"
import script from "./TUIViewer.vue?vue&type=script&lang=ts"
export * from "./TUIViewer.vue?vue&type=script&lang=ts"

import "./TUIViewer.vue?vue&type=style&index=0&id=50a1f96c&lang=css"
import "./TUIViewer.vue?vue&type=style&index=1&id=50a1f96c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a1f96c"]])

export default __exports__